import React from 'react';
import ReactDOM from 'react-dom';

import $ from 'jquery';
import moment from 'moment';
import './daterangepicker.min.js'
import './daterangepicker.css'
import './reactwrapper.css'


class DateRangePicker extends React.Component {
    constructor(props) {
        super(props);
        this.myRef = React.createRef();
    }

    componentDidMount(){
        this.initDatepicker();
    }
      
    initDatepicker(){
        $(this.myRef.current).daterangepicker(
            {
                timePicker: false,
                showDropdowns: true,
                opens: 'right',
                autoUpdateInput: false, // disable a default date range
                autoApply: true,
                minYear: 2010,
                maxYear: 2030,
                locale: {
                    format: 'DD MMM YYYY',
                    cancelLabel: 'Clear'
                },
                ranges: {
                    'Current Week': [moment().startOf('week'), moment()],
                    'Last 7 Days': [moment().subtract(6, 'days'), moment()],
                    'Last 30 Days': [moment().subtract(29, 'days'), moment()],
                    'Last 90 Days': [moment().subtract(89, 'days'), moment()],
                    'Current Month': [moment().startOf('month'), moment().endOf('month')],
                    'Last Month': [moment().subtract(1, 'month').startOf('month'), moment().subtract(1, 'month').endOf('month')],
                    'Last Year': [moment().subtract(1, 'year').startOf('day'), moment().startOf('day')]
                }
            }, 
            (start, end) => {
                // onChange event
                if(start._isValid && end._isValid) {
                    var value = start.format('DD MMM YYYY') + ' - ' + end.format('DD MMM YYYY')
                    $(this.myRef.current).val(value);
                    this.props.onChange(value);
                } else {
                    $(this.myRef.current).val('');
                    this.props.onChange('')
                }
            }
        );

        $('#datefilter #date-clear').on('click', () => {
            $(this.myRef.current).val('');
            this.props.onChange('')
        });
    }
      
    render(){
        return (
          <div id="datefilter">
            <input id="date-input" name={this.props.name} ref={this.myRef}  autoComplete="off" value={this.props.value} placeholder="Time interval"/>
            <span id="date-clear" title="Clear date filter"><i className="fa fa-times" aria-hidden="true"></i></span>
          </div>
        )
    }
}

export default DateRangePicker;